import {Component, OnInit} from '@angular/core';
import {AuthService} from '../auth/auth.service';
import {DocumentNewsService} from '../service/document-news.service';
import {DocumentNews} from '../model/document-news.model';

@Component({
  selector: 'news-widget',
  templateUrl: './news-widget.component.html'
})
export class NewsWidget implements OnInit {

  newsItems: DocumentNews[];

  constructor(public _authService: AuthService,
              private _docNewsService: DocumentNewsService) {
  }


  ngOnInit() {
    this.loadNewsItems();
  }

  loadNewsItems() {
    this._docNewsService.findTop()
      .subscribe(
        newsItems =>{ this.newsItems = newsItems;
      },
        err => {
          console.log(err);
        });
  }

}




// WEBPACK FOOTER //
// ./src/app/shared/news-widget/news-widget.component.ts